module.exports = {"320213001":"崇安寺街道","320213002":"通江街道","320213003":"广瑞路街道","320213004":"上马墩街道","320213005":"江海街道","320213006":"广益街道","320213007":"迎龙桥街道","320213008":"南禅寺街道","320213009":"清名桥街道","320213010":"金星街道","320213011":"金匮街道","320213012":"扬名街道","320213013":"黄巷街道","320213014":"山北街道","320213015":"北大街街道","320213016":"惠山街道"}


//////////////////
// WEBPACK FOOTER
// ./src/town/320213.json
// module id = 844
// module chunks = 0